export enum CmmDocType {
  CMM_SCREENSHOT = "cmm_screenshot",
  PRESCRIPTION = "prescription",
  INUSRANCE_CARD = "insurance_card",
  CLINICAL_ATTACHMENT = "clinical_attachment",
}
